/* istanbul ignore file */
import { Dropdown } from 'framework/form';
import React from 'react';
import { CANDIDATE_APPLICATION_SOURCE_NAMES } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationSourceNamesDropdown = (props: any) => {
  return (
    <Dropdown
      placeholder="Choose Source Name"
      options={Object.values(CANDIDATE_APPLICATION_SOURCE_NAMES).map(value => ({
        value,
        label: value,
      }))}
      label="Candidate application source name"
      {...props}
    />
  );
};

export default CandidateApplicationSourceNamesDropdown;
